import { CLIENT_URLS } from "constants/urls";
import Payment from "pages/Payment/desktop";
import DesktopAddress from "pages/DesktopAddress";
import CheckoutPayment from "layouts/CheckoutPayment/desktop";
import Auth from "../../pages/Auth";
import NotFound from "../../pages/NotFound";
import PaymentStatus from "../../pages/PaymentStatus";
import PrePaymentSuccess from "../../pages/PrePaymentSuccess";
import SimplOtpScreen from "../../pages/SimplOtpScreen";
import PostPayment from "../../pages/PostPayment";
import PaymentSuccessDesktop from "../../pages/PaymentSuccess/desktop";
import MySavedPaymentDesktop from "../../pages/MySavedPayment/desktop";
import InitiateRoutes from "pages";

export const desktopRoutes = [
  {
    path: [CLIENT_URLS.BASE_URL],
    component: InitiateRoutes,
    routes: [
      /**
       * auth page
       */
      {
        path: [CLIENT_URLS.AUTH_PAGE],
        component: Auth,
        footer: true,
        exact: true,
      },
      /**
       * payment routes
       */
      {
        path: [CLIENT_URLS.PAYMENT_BASE_URL],
        component: Payment,
        routes: [
          {
            path: [CLIENT_URLS.PAYMENT_BASE_URL],
            component: CheckoutPayment,
            footer: true,
            exact: true,
          },
          {
            path: [CLIENT_URLS.POST_PAYMENT_PAGE],
            component: PostPayment,
            footer: true,
            exact: true,
          },
          {
            path: [CLIENT_URLS.PAYMENT_SUCCESS_PAGE],
            component: PaymentSuccessDesktop,
            footer: true,
            exact: true,
          },
          {
            path: [CLIENT_URLS.MY_SAVED_PAYMENT_PAGE],
            component: MySavedPaymentDesktop,
            footer: true,
            exact: true,
          },
          {
            path: [CLIENT_URLS.SIMPL_OTP_PAGE],
            component: SimplOtpScreen,
            footer: true,
            exact: true,
          },
          {
            path: [CLIENT_URLS.PRE_PAYMENT_SUCCESS_PAGE],
            component: PrePaymentSuccess,
            footer: true,
            exact: true,
          },
          {
            path: [CLIENT_URLS.SIMPL_PAYMENT_STATUS_PAGE + "/:status"],
            component: PaymentStatus,
            footer: true,
            exact: true,
          },
          {
            path: "*",
            component: NotFound,
            status: 404,
          },
        ],
        footer: true,
      },
      /**
       * Address routes
       */
      {
        path: [CLIENT_URLS.ADDRESS_BASE_URL],
        component: DesktopAddress,
        footer: true,
      },
      {
        path: "*",
        component: NotFound,
        status: 404,
      },
    ],
    footer: true,
  },
  {
    path: "*",
    component: NotFound,
    status: 404,
  },
];
